module.exports = __webpack_public_path__ + "img/quietseas-logo-color.4e98fa72.png";